import BackgroundImage from '../../../src/modules/BackgroundImage';

customElements.define(

  "cc-product-card", 

  class extends HTMLElement{

    connectedCallback(){

        const imageURL = this.getAttribute("image");
        let label = this.getAttribute("label");
        let description = this.getAttribute("description");
        const element = this.innerHTML;

        if( label == "" || !label){
            label = "Product Name";
        }

        if( description == "" || !description ){
            description = "Product description.";
        }

        this.innerHTML = `
        <div id="cc-product-card">

            <div id="product-image">
    
            </div>
            <div id="product-information">

                <h3>${label}</h3>

                <p>${description}</p>

                ${element}
                
            </div>


        </div>      

        `;

        let imageContainer = this.querySelector("#product-image");

        if (imageContainer && imageURL != "" ) { 

            new BackgroundImage(imageURL, imageContainer);

        }

    }
       
  }

);